import dayjs from 'dayjs';

export const BASE_DATE_FORMAT = 'MMM DD, YYYY';
export const DATE_TIME_FORMAT = 'MMM D, YYYY h:mm A';

export const DATE_FORMATS = {
  base: BASE_DATE_FORMAT,
  datetime: DATE_TIME_FORMAT,
};

export function formatDate(value: string) {
  return dayjs(value).format(DATE_FORMATS.base);
}

export function formatDateTime(value: string) {
  return dayjs(value).format(DATE_FORMATS.datetime);
}
